import { UUID } from "angular2-uuid";

export interface PassAlertFailFieldItemValueArgs {
    id?: string;
    optionId?: string;
    result?: string;
    comment?: string;
}

const defaults = () => {
    return {
        id: UUID.UUID(),
        optionId: "",
        result: "",
        comment: ""
    };
};

export class PassAlertFailFieldItemValue {
    id: string;
    optionId: string;
    result: string;
    comment: string;

    constructor(args?: PassAlertFailFieldItemValueArgs) {

        args = {...defaults(), ...args};
        Object.keys(args).forEach(key => this[key] = args[key]);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/pass-alert-fail/form/pass-alert-fail-control-item-value.model.ts